import { CookieNotice } from "components/widgets/CookieNotice";
import { setCookieNotice } from "utils/storage";
import { onCloseCookieNotice } from "components/popups/PopupDispatcher";
import { useCallback } from "react";

const CookieNoticeWrapper = (): JSX.Element => {
  const onOK = useCallback(() => {
    setCookieNotice("ok");
    onCloseCookieNotice();
  }, []);

  const onCancel = useCallback(() => {
    setCookieNotice("cancel");
    onCloseCookieNotice();
  }, []);

  return <CookieNotice onOK={onOK} onCancel={onCancel} />;
};

export default CookieNoticeWrapper;
